module.exports = __webpack_public_path__ + "static/img/index.167474f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/index.png
// module id = 26
// module chunks = 2 3 4 5 7 9 11 12 13